var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"toggle",class:{'toggle--disabled': _vm.disabled}},[_c('span',{staticClass:"toggle__status",class:_vm.toggleStatusClass,on:{"click":_vm.onClickIcon}},[_c('i',{staticClass:"fa",class:{
        'fa-toggle-on'  : _vm.toggled,
        'fa-toggle-off' : !_vm.toggled,
      }})]),_c('span',{staticClass:"toggle__label",class:{'text-muted': _vm.disabled},on:{"click":_vm.onClickLabel}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }